import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { User } from 'src/app/components/create-nedit-poc/create-nedit-poc.component';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AddProposalService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private apiUrl = environment.apiUrl;




  constructor(private http: HttpClient) {

  }



  convertToBase64(file) {
    var base64String = ""
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      return reader.result.toString();
    };
    return base64String;
  }
  public getProposalDataById(id) {

    const url = this.apiUrl + "Proposal/" + id;
    return this.http.get<any>(url, this.httpOptions);
  }



  saveProposal(requestData): Observable<any> {
    const url = `${this.apiUrl}Proposal/create`;
    return this.http.post<any>(url, requestData, this.httpOptions);
  }
  AddServiceOffering(requestData) {

    const url = `${this.apiUrl}Proposal/AddServicesOffering?servicerOffering=${requestData}`;
    return this.http.post<any>(url, this.httpOptions);
  }
  AddServiceLine(requestData) {
    const url = `${this.apiUrl}Competency/AddServiceLine?serviceLine=${requestData}`;

    return this.http.post<any>(url, this.httpOptions);
  }
  AddServiceArea(requestData) {
    const url = `${this.apiUrl}Proposal/AddServiceArea`
    return this.http.post<any>(url, requestData, this.httpOptions);
  }
  AddServiceType(requestData) {
    const url = `${this.apiUrl}Proposal/AddServiceType?serviceType=${requestData}`;
    return this.http.post<any>(url, this.httpOptions);
  }
  AddSkill(skill, campetencyId, subCompId) {

    const url = `${this.apiUrl}Competency/AddSkill?skill=${skill}&competencyId=${campetencyId}&subCompetencyId=${subCompId}`;

    return this.http.post<any>(url, this.httpOptions);
  }
  AddSubServiceLine(selectedId, field) {
    const url = `${this.apiUrl}Competency/AddSubServiceLine?serviceLineId=${selectedId}&subServiceLine=${field}`;
    return this.http.post<any>(url, this.httpOptions);
  }
  getSub(serviceLineId) {
    const url = `${this.apiUrl}/Competency/GetSubCompetenciesForDropDowns?competencyId=${serviceLineId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  AddDomain(requestData: any, description) {
    const url = `${this.apiUrl}Proposal/CreateDomain?domain=${requestData}&description=${description}`;
    return this.http.post<any>(url, this.httpOptions);
  }
  AddLocation(requestData) {
    const url = `${this.apiUrl}Proposal/CreateClientLocation?clientLocation=${requestData}`;
    return this.http.post<any>(url, this.httpOptions);
  }
  addTechStack(requestData) {

    const url = `${this.apiUrl}Competency/AddSkill?skill=${requestData}&competencyId=1&subCompetencyId=1`;

    return this.http.post<any>(url, this.httpOptions);
  }
  addSkill(requestData: any, competencyId, subCompetencyId) {
    const url = `${this.apiUrl}Competency/AddSkill?skill=${requestData}&competencyId=${competencyId}&subCompetencyId=${subCompetencyId}`
    return this.http.post<any>(url, this.httpOptions);
  }

  editProposal(requestData) {

    const url = `${this.apiUrl}Proposal/update`;
    return this.http.put<any>(url, requestData, this.httpOptions);
  }
  getClientPartnerDetails(searchText) {
    const url = `${this.apiUrl}Profile/Autocomplete?search=${searchText}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getTechStack(payload: any[]): Observable<any> {
    const url = `${this.apiUrl}Competency/GetAllSkills`;
    return this.http.post<any>(url, payload, this.httpOptions);

  }

  fetchEmployees(query: string): Observable<any> {
    return this.http.get<User[]>(`${this.apiUrl}Profile/GetBasicEmployeeDetails?searchTerm=${query}`);
  }

  getserviceOffering() {
    const url = `${this.apiUrl}Proposal/GetAllServicesOffering`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getfileTypes() {
    const url = `${this.apiUrl}Proposal/GetAllProposalDocumentTypes`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getLocations() {
    const url = `${this.apiUrl}Proposal/GetAllClientLocations`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getServiceLines() {
    const url = `${this.apiUrl}Competency/GetCompetenciesForDropDowns`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getServiceLines2(id) {
    const url = `${this.apiUrl}Competency/GetCompetencyNameById?competencyId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getSubServiceLines(id) {
    const url = `${this.apiUrl}Competency/GetSubCompetenciesForDropDowns?competencyId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getCompetency(id) {

    const url = `${this.apiUrl}Competency/GetSubCompetenciesForDropDowns?competencyId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getCompetencies(templateId, subTemplateId) {
    const url = `${this.apiUrl}Template/GetCompetenciesForDropDowns?templateId=${templateId}&subTemplateId=${subTemplateId}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getTemplatesDropdown() {
    const url = `${this.apiUrl}Template/GetTemplatesForDropDowns`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getSubTemplatesDropdown(id) {
    const url = `${this.apiUrl}Template/GetSubTemplatesForDropDowns?templateId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getDownloadLink(sharepointId) {
    const url = `${this.apiUrl}Graph/getFileDownloadLink/${sharepointId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getTempates(competencyId, subCompetencyId) {
    const url = `${this.apiUrl}Competency/GetTemplatesForDropDowns?competencyId=${competencyId}&subCompetencyId=${subCompetencyId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getServiceAreas() {
    const url = `${this.apiUrl}Competency/GetAllServiceAreas`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getServiceAreasById(id) {
    const url = `${this.apiUrl}Competency/GetServiceAreasByCompetencyId?competencyId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getServiceTypes() {
    const url = `${this.apiUrl}Proposal/GetAllServiceTypes`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getDomains() {
    const url = `${this.apiUrl}SME/GetDomains`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getVerticals(){
    const url = `${this.apiUrl}Proposal/GetAllVerticals`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getSubVerticals(id){
    const url = `${this.apiUrl}Proposal/GetAllSubVerticals?verticalId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  downloadAttachment(fileId, proposalId) {
    const url = `${this.apiUrl}Proposal/Download/${fileId}?proposalId=${proposalId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  downloadSharepointFile(sharepointId) {
    const url = `${this.apiUrl}Graph/getFileDownloadLink/${sharepointId}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  AddCompilance(data) {
    const url = `${this.apiUrl}Compilance/CreateCompilance`;
    return this.http.post<any>(url, data, this.httpOptions);
  }
  GetComplianceData(searchText, from, size) {
    const url = this.apiUrl + "Compilance/GetAllCompilances?queryString=" + searchText + "&from=" + from + "&size=" + size;
    return this.http.get<any>(url, this.httpOptions);
  }

  UpdateCompliance(data) {
    const url = `${this.apiUrl}Compilance/update`;
    return this.http.put<any>(url, data, this.httpOptions);
  }

  public getComilanceDataById(id) {

    const url = this.apiUrl + "Compilance/" + id;
    return this.http.get<any>(url, this.httpOptions);
  }

  delComilanceData(id) {
    const url = this.apiUrl + "Compilance/DeleteCompilance?compilanceId=" + id;
    return this.http.delete<any>(url, this.httpOptions);
  }

  public downloadOnlyCompilance(id) {

    const url = this.apiUrl + "Compilance/DownloadOnlyCompilanceAttachment?compilanceId=" + id;
    return this.http.get<any>(url, this.httpOptions);
  }

  public downloadCompliance(id) {

    const url = this.apiUrl + "Compilance/DownloadComplianceAttachment?compilanceId=" + id;
    return this.http.get<any>(url, this.httpOptions);
  }

  getAllCountries() {
    const url = `${this.apiUrl}Compilance/GetAllCountries`;
    return this.http.get<any>(url, this.httpOptions);
  }
  GetAllComplianceTypes() {
    const url = `${this.apiUrl}Compilance/GetAllComplianceTypes`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getAllRegions() {
    const url = `${this.apiUrl}Compilance/GetAllRegion`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getComplianceById(id: number) {
    const url = `${this.apiUrl}Compilance/` + id;
    return this.http.get<any>(url, this.httpOptions);
  }

  getAllCitiesForHeader() {
    const url = `${this.apiUrl}Compilance/GetAllCitiesForeaders`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getAllOfficeLocationsForHeader() {
    const url = `${this.apiUrl}Compilance/GetAllLocationsForeaders`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getLocationsByCountryId(regionId, id, search, cityId) {
    const url = this.apiUrl + "Compilance/GetAllLocations?search=" + search + "&regionId=" + regionId + "&countryId=" + id + "&cityId=" + cityId;
    return this.http.get<any>(url, this.httpOptions);
  }

  public AddNewLocation(result, regionId, countryId, cityId) {
    ;
    const url = `${this.apiUrl}Compilance/AddLocation?location=${result}&regionId=${regionId}&countryId=${countryId}&cityId=${cityId}`;
    return this.http.post<any>(url, this.httpOptions);
  }

  getLocationsByCountryID(id) {
    const url = `${this.apiUrl}Compilance/GetLocationsByCountryId?countryId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getCountryByRegionId(id) {
    const url = `${this.apiUrl}Compilance/GetCountryByRegionId?regionId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getCityByCountryId(regionId, id, search) {
    const url = this.apiUrl + "Compilance/GetAllCities?search=" + search + "&regionId=" + regionId + "&countryId=" + id;
    return this.http.get<any>(url, this.httpOptions);
  }

  public AddComplianceType(result) {
    ;
    const url = `${this.apiUrl}Compilance/CreateNewCompliancetype?compliance=${result}`;
    return this.http.post<any>(url, this.httpOptions);
  }

  public AddRegion(result) {
    ;
    const url = `${this.apiUrl}Compilance/AddRegion?serviceLine=${result}`;
    return this.http.post<any>(url, this.httpOptions);
  }

  public AddNewCountry(result, id) {
    ;
    const url = `${this.apiUrl}Compilance/AddCountry?regionId=${id}&countryName=${result}`;
    return this.http.post<any>(url, this.httpOptions);
  }

  AddNewCity(result, regionId, countryId) {
    ;
    const url = `${this.apiUrl}Compilance/AddCity?city=${result}&regionId=${regionId}&countryId=${countryId}`;
    return this.http.post<any>(url, this.httpOptions);
  }
  createComplains(request) {
    const url = `${this.apiUrl}Compilance/CreateCompilance`;
    return this.http.post<any>(url, request, this.httpOptions);
  }

  buildFetchEmployeeByCompIdUrl(url, CountryId, RegionId, CityId, searchText, selectedYear) {
    if (CountryId != null && CountryId != 0 && !Number.isNaN(CountryId))
      url = `${url}&countryId=${CountryId}`
    if (RegionId != null && RegionId != 0 && !Number.isNaN(RegionId))
      url = `${url}&regionId=${RegionId}`
    if (CityId != null && CityId != 0 && !Number.isNaN(CityId))
      url = `${url}&cityId=${CityId}`
    if (selectedYear != null && selectedYear != 0 && !Number.isNaN(selectedYear))
      url = `${url}&createdYear=${selectedYear}`
    if (searchText != null)
      url = `${url}&Search=${searchText}`
    return url
  }

  public getAllCompliancesByFilter(from: number, size: number, CountryId, RegionId, CityId, searchText, selectedYear) {

    let url = `${this.apiUrl}Compilance/FetchCompliances?from=${from}&size=${size}`;
    url = this.buildFetchEmployeeByCompIdUrl(url, CountryId, RegionId, CityId, searchText, selectedYear)
    return this.http.get<any>(url, this.httpOptions);
  }
  getAllCompilanceName() {
    const url = `${this.apiUrl}Compilance/GetAllCompilanceName`;
    return this.http.get<any>(url, this.httpOptions);
  }

}